import { Locales } from "@app/types/question";

const COOKIE_KEY = "cast_language";

function getCookie(name: string): string | null {
  const match = document.cookie.match(
    new RegExp("(^| )" + name + "=([^;]+)")
  );
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(
  name: string,
  value: string,
  days = 365
) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

export function getLanguage(): Locales {
  return getCookie(COOKIE_KEY) as Locales;
}

export function setLanguage(lang: Locales) {
  setCookie(COOKIE_KEY, lang);
}